// src/store/slices/userProfileSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CensusProfileSlice {
    selectedView: string;
}

const initialState: CensusProfileSlice = {
    selectedView: 'info',
};

const censusProfileSlice = createSlice({
    name: 'censusProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = censusProfileSlice.actions;
export default censusProfileSlice.reducer;